<button
  pButton
  pRipple
  [type]="type"
  [disabled]="disabled || loading"
  [class]="buttonClasses + ' ' + primeButtonClasses"
  [icon]="loading ? 'pi pi-spin pi-spinner' : icon || ''"
  [label]="label"
  [pTooltip]="tooltip || ''"
  (click)="onButtonClick($event)"
>
  <!-- Spinner personalizado si está cargando -->
  <ng-container *ngIf="loading && !icon">
    <i class="pi pi-spin pi-spinner action-button__spinner"></i>
  </ng-container>

  <!-- Contenido del slot para casos especiales -->
  <ng-content></ng-content>
</button>
